import React from "react";
import ReactCrop, { Crop as ICrop } from 'react-image-crop';
import "react-image-crop/dist/ReactCrop.css";
import { post } from '../../../model/post';
import Button from '../../../ui-components/Button/Button';

interface ICropperProps {
    changeImageBase64: (post: post, newValue: string) => void;
    post: post;
    classes: any;
}

interface ICropperState {
    src: any,
    crop: ICrop,
    croppedImageUrl: any,
    imageRef: any,
    fileUrl: string
}
const defaultState = {
    src: null,
    crop: {
        unit: "%" as "%",
        width: 30,
        aspect: 4 / 4
    },
    croppedImageUrl: null,
    imageRef: null,
    fileUrl: null
}
class Cropper extends React.Component<ICropperProps, ICropperState>
{
    constructor(props: ICropperProps) {
        super(props);
        this.state = defaultState;
    }

    onSelectFile = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () =>
                this.setState({ src: reader.result })
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    onImageLoaded = (image: any) => {
        this.setState({ imageRef: image });
        this.props.changeImageBase64(this.props.post, this.getCroppedImgBase64(image, this.state.crop, this.props.post));
    };

    onCropComplete = (crop: any) => {
        this.makeClientCrop(crop);
        this.props.changeImageBase64(this.props.post, this.getCroppedImgBase64(this.state.imageRef, crop, this.props.post));
    };

    onCropChange = (crop: any) => {
        this.setState({ crop: crop });
        //debugger;
        this.props.changeImageBase64(this.props.post, this.getCroppedImgBase64(this.state.imageRef, crop, this.props.post));
    };

    async makeClientCrop(crop: any) {
        if (this.state.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.state.imageRef,
                crop,
                "newFile.png"
            );
            this.setState({ croppedImageUrl: croppedImageUrl });
            this.getCroppedImgBase64(this.state.imageRef, crop, this.props.post)
        }
    }

    getCroppedImg(image: any, crop: any, fileName: any) {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob: any) => {
                if (!blob) {
                    console.error("Canvas is empty");
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.state.fileUrl);
                const _fileUrl = window.URL.createObjectURL(blob);
                this.setState({ fileUrl: _fileUrl });
                resolve(this.state.fileUrl);
            }, "image/png");
        });
    }

    private getCroppedImgBase64(image: any, crop: any, post: post) {
        if (image) {
            const canvas = document.createElement("canvas");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext("2d");

            ctx.drawImage(
                image,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                crop.width,
                crop.height
            );
            const base64Image = canvas.toDataURL('image/png');
            this.props && this.props.changeImageBase64 && this.props.changeImageBase64(post, base64Image);
            return base64Image
        }
    }
    conferma = () => {
        this.setState({ ...defaultState });
    }
    annulla = () => {
        this.setState({ ...defaultState });
        this.props.changeImageBase64(this.props.post, undefined);
    }

    render() {
        const { crop, src } = this.state;
        const styles = {
            container: {
                cursor: 'pointer',
                position: 'absolute' as 'absolute',
                top: '0',
                bottom: '0',
                right: '0',
                left: '0',
                width: '100%',
                opacity: 0
            },
        }

        return (
            <>
                <div className="cropper">
                    <Button className={this.props.classes.buttons} onClick={() => { }}>
                        Carica un' immagine da associare al Post
                        <input id="imageButton" style={styles.container} onChange={this.onSelectFile} type="file"></input>
                    </Button>

                    {src && (<>
                        <ReactCrop
                            src={src}
                            crop={crop}
                            onImageLoaded={this.onImageLoaded}
                            onComplete={this.onCropComplete}
                            onChange={this.onCropChange}
                        />
                    </>
                    )}
                </div>
            </>
        );
    }
}

export default Cropper;